/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Detail_IpInputs */

const en_audit_detail_ip = /** @type {(inputs: Audit_Detail_IpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP`)
};

const pt_br2_audit_detail_ip = /** @type {(inputs: Audit_Detail_IpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP`)
};

/**
* | output |
* | --- |
* | "IP" |
*
* @param {Audit_Detail_IpInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_detail_ip = /** @type {((inputs?: Audit_Detail_IpInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Detail_IpInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_detail_ip(inputs)
	return pt_br2_audit_detail_ip(inputs)
});